module.exports = __webpack_public_path__ + "static/media/og04.3d3bcbfa.webp";